export const blogArticles = [
  {
    id: 10,
    title: 'Ruben Ramos and Los Texmaniacs: Grammy Recognition for Roots Music Done Right',
    excerpt: 'At the Grammy Awards, a collaborative tribute to Clifton Chenier reminded us that music built on craft, tradition, and respect travels farther than trends ever could.',
    image: 'https://public.readdy.ai/ai/img_res/78e4052b95868f256eea4bd4e8ebee02.jpg',
    category: 'Artists',
    date: 'Feb 2, 2026',
    readTime: '5 min read'
  },
  {
    id: 1,
    title: 'Rising Stars: The New Wave of Texas Country',
    excerpt: 'Discover the emerging artists who are reshaping the Texas Country landscape with fresh sounds and authentic storytelling.',
    image: 'https://readdy.ai/api/search-image?query=Young%20country%20music%20artist%20performing%20with%20acoustic%20guitar%20on%20rustic%20Texas%20ranch%20stage%20at%20sunset%20with%20warm%20amber%20lighting%20and%20southwestern%20aesthetic%20simple%20clean%20background%20showcasing%20authentic%20Texas%20country%20music%20scene%20artistic%20photography%20with%20rich%20warm%20tones%20and%20natural%20lighting&width=600&height=400&seq=ranchfireblog1&orientation=landscape',
    category: 'Artists',
    date: 'Mar 15, 2024',
    readTime: '6 min read'
  },
  {
    id: 2,
    title: 'Tejano Influence: Bridging Two Musical Worlds',
    excerpt: 'Exploring how Tejano music continues to shape and influence modern Texas Country, creating a unique cultural fusion.',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20southwestern%20desert%20landscape%20at%20golden%20hour%20with%20warm%20amber%20and%20orange%20tones%20simple%20clean%20background%20celebrating%20Latino%20heritage%20and%20Texas%20country%20music%20fusion%20artistic%20photography%20with%20rich%20saturated%20colors&width=600&height=400&seq=ranchfireblog2&orientation=landscape',
    category: 'Culture',
    date: 'Mar 12, 2024',
    readTime: '7 min read'
  },
  {
    id: 3,
    title: 'Red Dirt Revolution: Oklahoma Meets Texas',
    excerpt: 'The story of how Red Dirt music from Oklahoma merged with Texas Country to create a powerful regional movement.',
    image: 'https://readdy.ai/api/search-image?query=Rustic%20Texas%20ranch%20scene%20at%20sunset%20with%20warm%20golden%20light%20and%20red%20dirt%20roads%20simple%20clean%20background%20showcasing%20authentic%20country%20music%20atmosphere%20artistic%20photography%20with%20warm%20amber%20tones&width=600&height=400&seq=ranchfireblog3&orientation=landscape',
    category: 'Culture',
    date: 'Mar 10, 2024',
    readTime: '5 min read'
  }
];
